import React from "react";
import EditablePersianSupportNumericTextField from "../../../EditablePersianSupportNumericTextField";
import PersianSupportTextField from "Global/Components/UnEditableComponents/PersianSupportTextField/PersianSupportTextField";

const NumericEditTernary = ({ field, element, onChange }) => {
  return (
    <React.Fragment>
      {Number(field.value) ? (
        <EditablePersianSupportNumericTextField
          label={element?.LablelNameForWeb}
          onChange={onChange}
          isEnglish={true}
          value={field?.value}
        />
      ) : (
        <PersianSupportTextField
          label={element?.LablelNameForWeb}
          onChange={onChange}
          isEnglish={true}
        />
      )}
    </React.Fragment>
  );
};

export default NumericEditTernary;
